import { showToast, ToastTypes } from "@components/molecules/VDBToast/util";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Toast from "react-native-toast-message";

const useWebConnectionListener = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { t } = useTranslation();

  const updateStatus = () => {
    setIsOnline(navigator.onLine);
    if (!navigator.onLine) {
      showToast(
        t("global.titleText.internetDisconnected", "Connection Error"),
        t(
          "global.text.internetDisconnected",
          "Please check your internet connection"
        ),
        ToastTypes.ERROR,
        true,
        true,
        0,
        () => null,
        false
      );
    } else {
      Toast.hide();
    }
  };

  useEffect(() => {
    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);

    updateStatus();

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  return isOnline;
};

export default useWebConnectionListener;
